import { useEffect, useState } from "react"
import { getAllUsers, getNumberOfUsers, removeUser, getUsersByQuery, getNumberOfQueryUsers } from "../../HTTP/admin"
import TableElements from './TableElements';
import ListElementsMobile from "./ListElementsMobile";
import SearchComponent from "./SearchComponent";
import Pagination from "../../Helper/Pagination";

export default function UserAdmin() {
    const localUser = JSON.parse(localStorage.getItem("user"))
    if (!localUser.super_admin && localUser.admin_access !== 1) {
        window.location.href = '/'
    }
    const url = new URL(window.location.href)
    if (url.searchParams.get('page') === null) {
        url.searchParams.set('page', 1);
        window.history.pushState({}, '', url);
    }
    if (url.searchParams.get('country') === null) {
        url.searchParams.set('country', 'ac');
        window.history.pushState({}, '', url);
    }

    const [users, setUsers] = useState([])
    const [searchTerm, setSearchTerm] = useState(url.searchParams.get('query') === null ? '' : url.searchParams.get('query'));
    const [searchDone, setSearchDone] = useState(false)
    const [country] = useState(url.searchParams.get('country') === null ? '' : url.searchParams.get('country'));
    const [currentPage] = useState(parseInt(url.searchParams.get('page')));
    const [usersPerPage] = useState(6);
    const [nbUsers, setNbUsers] = useState(0);
    const [selectedUserIds, setSelectedUserIds] = useState([]);
    const [isDeletingUsers, setIsDeletingUsers] = useState(false);

    useEffect(() => {
        const funNumberUsers = async () => {
            if (searchTerm !== '') {
                const numberUsers = await getNumberOfQueryUsers(searchTerm, country)
                setNbUsers(numberUsers)
            } else {
                const numberUsers = await getNumberOfUsers(country)
                setNbUsers(numberUsers)
            }
        }
        funNumberUsers()
        const funSearchUsers = async () => {
            if (searchTerm !== '') {
                const searchUsers = await getUsersByQuery((currentPage - 1) * usersPerPage, currentPage * usersPerPage, searchTerm, country)
                setUsers(searchUsers)
            } else {
                const searchUsers = await getAllUsers((currentPage - 1) * usersPerPage, currentPage * usersPerPage, country)
                setUsers(searchUsers)
            }
        }
        funSearchUsers()
        setSearchDone(true)
    }, [country, currentPage, searchTerm, usersPerPage])

    useEffect(() => {
        const visibleUserIds = users.map((user) => user.id);
        setSelectedUserIds((previousIds) => previousIds.filter((id) => visibleUserIds.includes(id)));
    }, [users]);
    
    // Change page
    const paginate = (pageNumber) => {
        window.location.href = "/admin/users?page=" + pageNumber + (url.searchParams.get("query") === null ? '' : "&query=" + url.searchParams.get("query")) + (url.searchParams.get("country") === null ? '' : "&country=" + url.searchParams.get("country"))
    }

    const handleQuery = (e) => {
        e.preventDefault()
        if (url.searchParams.get('query') === null) {
            url.searchParams.set('query', searchTerm);
            window.history.pushState({}, '', url);
        }
        window.location.href = "/admin/users?page=1&query=" + searchTerm + "&country=" + country
    }

    const handleEditUser = (id) => {
        window.location.href = "/admin/users/edit/" + id
    }

    const handleAddUser = () => {
        window.location.href = "/admin/users/add"
    }

    const handleAddManyUsers = () => {
        window.location.href = "/admin/users/add-many"
    }
    
    const handleChangeCountry = (event) => {
        window.location.href = "/admin/users?page=1&query=&country="  + event.target.value
    }

    const handleDelete = (id) => {
        if (window.confirm("Are you sure you want to delete this user ?")) {
            setIsDeletingUsers(true)
            removeUser(id)
                .then(() => {
                    alert("User deleted !")
                    window.location.href = "/admin/users?page=" + currentPage + (url.searchParams.get("query") === null ? '' : "&query=" + url.searchParams.get("query")) + (url.searchParams.get("country") === null ? '' : "&country=" + url.searchParams.get("country"))
                })
                .catch(() => alert("Error while deleting user"))
                .finally(() => setIsDeletingUsers(false))
        } else {
            alert("Canceled deletion");
        }
    }

    const handleToggleSelectUser = (id) => {
        setSelectedUserIds((previousIds) => previousIds.includes(id)
            ? previousIds.filter((userId) => userId !== id)
            : [...previousIds, id]
        );
    }

    const handleToggleSelectAllUsers = () => {
        const visibleUserIds = users.map((user) => user.id);
        const areAllVisibleUsersSelected = visibleUserIds.length > 0 && visibleUserIds.every((id) => selectedUserIds.includes(id));

        if (areAllVisibleUsersSelected) {
            setSelectedUserIds((previousIds) => previousIds.filter((id) => !visibleUserIds.includes(id)));
        } else {
            setSelectedUserIds((previousIds) => [...new Set([...previousIds, ...visibleUserIds])]);
        }
    }

    const handleBulkDelete = async () => {
        if (selectedUserIds.length === 0) {
            alert("Select at least one user")
            return
        }

        if (!window.confirm(`Are you sure you want to delete ${selectedUserIds.length} user(s) ?`)) {
            return
        }

        setIsDeletingUsers(true)
        const deletionResults = await Promise.allSettled(selectedUserIds.map((id) => removeUser(id)))
        const successCount = deletionResults.filter((result) => result.status === 'fulfilled' && result.value === true).length
        const errorCount = selectedUserIds.length - successCount

        if (errorCount > 0) {
            alert(`${successCount} user(s) deleted, ${errorCount} failed`)
        } else {
            alert(`${successCount} user(s) deleted !`)
        }

        window.location.href = "/admin/users?page=" + currentPage + (url.searchParams.get("query") === null ? '' : "&query=" + url.searchParams.get("query")) + (url.searchParams.get("country") === null ? '' : "&country=" + url.searchParams.get("country"))
    }

    return (
        <div className="flex flex-row mt-8">
            <div className="flex-grow px-4 sm:px-6 lg:px-8">
                <div className="flex flex-col sm:flex-row items-center justify-normal sm:justify-between mb-6 mt-8 xl:mt-0">
                    <h1 className="text-2xl font-bold text-center flex-grow mt-2">
                        Modération des utilisateurs
                    </h1>
                    <div className="w-full sm:w-auto flex flex-col sm:flex-row gap-2 sm:ml-4 mt-3 sm:mt-0">
                        <button
                            type="button"
                            onClick={handleAddManyUsers}
                            className="w-full sm:w-auto bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded-lg whitespace-nowrap"
                        >
                            Ajouter en masse
                        </button>
                        <button
                            type="button"
                            onClick={handleBulkDelete}
                            disabled={selectedUserIds.length === 0 || isDeletingUsers}
                            className="w-full sm:w-auto bg-red-500 hover:bg-red-700 disabled:bg-red-300 text-white font-bold py-2 px-4 rounded-lg whitespace-nowrap"
                        >
                            {isDeletingUsers ? "Suppression..." : `Supprimer la sélection (${selectedUserIds.length})`}
                        </button>
                    </div>
                </div>
                <SearchComponent
                    searchTerm={searchTerm}
                    setSearchTerm={setSearchTerm}
                    handleQuery={handleQuery}
                    dropdownList={localUser.super_admin === 1 ? {select:'Pays', value:country, handle:handleChangeCountry} : {}}
                    otherButton={{title:'Ajouter', handle:handleAddUser}}
                />
                <div className='hidden xl:block'>
                    <TableElements 
                        columns={[{props:'lastname',display:"Nom"}, 
                        {props:'firstname',display:"Prénom"}, 
                        {props:'email',display:"Email"}, 
                        {props:'country',display:"Pays", format:'country'}, 
                        {props:'',display:"Actions"}
                        ]}
                        data={users}
                        buttons={[{display:'Éditer',action:handleEditUser, color:'blue', props:'id'}, 
                        {display:'Supprimer',action:handleDelete, color:'red', props:'id'}]}
                        selectable={true}
                        selectedIds={selectedUserIds}
                        onToggleSelect={handleToggleSelectUser}
                        onToggleSelectAll={handleToggleSelectAllUsers}
                    />
                </div>
                <div className="xl:hidden w-full px-4 space-y-4">
                    <ListElementsMobile 
                        columns={[{props:'lastname',display:"Nom"}, 
                        {props:'firstname',display:"Prénom"}, 
                        {props:'email',display:"Email"}, 
                        {props:'country',display:"Pays", format:'country'}, 
                        {props:'',display:"Actions"}
                        ]}
                        data={users}
                        buttons={[{display:'Éditer',action:handleEditUser, color:'blue', props:'id'}, 
                        {display:'Supprimer',action:handleDelete, color:'red', props:'id'}]}
                        little={true}
                        selectable={true}
                        selectedIds={selectedUserIds}
                        onToggleSelect={handleToggleSelectUser}
                    />
                </div>
                {searchDone && <Pagination
                    itemsPerPage={usersPerPage}
                    totalItems={nbUsers}
                    paginate={paginate}
                    currentPage={currentPage}
                />}
            </div>
        </div>
    )
}
